import type { ICartPricing } from 'hooks/useDCSTypes';
import { readCookie } from './Cookies';

type ContactSalesCtaCookie = {
  bundleIds: string[];
};

/**
 * Checks if optimizely contactSalesCtaGroup cookie contains the bundle ID
 *
 * @param pricings
 * @returns true if user has cookie and bundle ID is in cookie, false otherwise
 */
const isBundleInOptimizelyContactSalesCtaGroup = (pricings?: ICartPricing | null) => {
  const contactSalesCtaCookieWithEmptyBundleIds = '{ "bundleIds": [] }';
  const contactSalesCtaCookie = readCookie('contactSalesCtaGroup') || contactSalesCtaCookieWithEmptyBundleIds;
  const parsedContactSalesCtaCookie = JSON.parse(contactSalesCtaCookie) as ContactSalesCtaCookie;

  return !!pricings && parsedContactSalesCtaCookie.bundleIds.includes(pricings.id);
};

export function isBundleSelfServicePurchaseEnabled(pricings?: ICartPricing | null): boolean {
  return (
    !!pricings?.isSelfServicePurchaseEnabled &&
    pricings.includedProducts.every(({ product }) => product.isSelfServicePurchaseEnabled)
  );
}

/**
 * Checks if bundle is self-service purchasable and bundle+user not in optimizely contactSalesCtaGroup cookie
 *
 * @param pricings
 * @returns true if bundle is self-service purchasable and bundle+user not in optimizely contactSalesCtaGroup cookie, false otherwise
 */
export const canAddToCart = (pricings?: ICartPricing | null) =>
  !isBundleInOptimizelyContactSalesCtaGroup(pricings) && isBundleSelfServicePurchaseEnabled(pricings);
